mutation UpdateOrganizationBillingRequisites(
  $id: ID!
  $input: OrganizationBillingRequisitesInput!
) {
  updateOrganizationBillingRequisites(id: $id, input: $input) {
    id
    billingRequisites {
      companyName
      registrationNumber
      vatNumber
      address
      contactName
      contactEmail
      invoiceEmails
      contractNumber
      contractDate
      filled
    }
  }
}
